import React from "react";
import { FaRegUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import { decodeWithSalt } from "../../../utils/encodeFunctions";
import { UserRole } from "../../../enums/UserRole";

function LoggedInDropdown() {
  let role = decodeWithSalt(sessionStorage.getItem("role") ?? "");

  function handleLogout(): void {
    sessionStorage.clear();
  }
  return (
    <div className="dropdown">
      <button
        className="btn btn-danger dropdown-toggle text-white"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        <FaRegUser size={25} color="white" />
      </button>
      <ul className="dropdown-menu">
        <li>
          <Link to="/ad-settings" className="dropdown-item">
            Ad Settings
          </Link>
        </li>
        <li>
          <Link to="/profile-settings" className="dropdown-item">
            Profile Settings
          </Link>
        </li>
        {(role === UserRole.ROOT || role === UserRole.ADMIN) && (
          <li>
            <Link to="/admin/dashboard" className="dropdown-item">
              Admin Console
            </Link>
          </li>
        )}
        <li>
          <Link to="/" onClick={handleLogout} className="dropdown-item">
            Logout
          </Link>
        </li>
      </ul>
    </div>
  );
}

export default LoggedInDropdown;
